'use client'

import { Select } from 'fukku/Select'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import { sendFamilyChangeClick } from '../../analytics/events'
import { useFamilies } from '../../contexts/FamiliesProvider/FamiliesProvider'

import styles from './Families.module.scss'

export function Families(): React.ReactNode {
	const { t } = useLabels()
	const { families, selectedFamilyId, selectFamilyId } = useFamilies()

	const handleFamilyChange = (newFamilyId: string | number | null): void => {
		if (typeof newFamilyId === 'string') {
			sendFamilyChangeClick()
			selectFamilyId(newFamilyId)
		}
	}

	return (
		<div className={styles.families}>
			<Select
				id='sizeGuide.families.selector'
				name='family'
				label={t('sizeGuide.familySelector.title')}
				value={selectedFamilyId}
				onChange={handleFamilyChange}
				options={families}
				data-testid='sizeGuide.families.selector'
			/>
		</div>
	)
}
